import axios from 'axios';
import { Component } from 'react';
import { type } from 'jquery';
import host from '../ipaddress'


const header1 = {
    'Authorization': localStorage.getItem('token'),
}
const headers =
{
    'Content-Type': 'application/json',
    'user': localStorage.getItem("user_id"),
    'timezone': 'Asia/Kolkata',
    'token': localStorage.getItem("token")
}

class ApiUrlCall {
    // Helper to get fresh auth headers (token may change after refresh)
    static getAuthHeaders() {
        return {
            'Authorization': localStorage.getItem('token'),
        };
    }

    showLosNumber(){
        return axios.post(host+'/v1/mpgps/landerDashboard/get_cars24_data/',{},{headers : ApiUrlCall.getAuthHeaders()})
    }
    send_analytics(data){

        return axios.post(host+'/v1/mpgps/landerDashboard/collect_analytics/',data,{headers: ApiUrlCall.getAuthHeaders()})

    }

    getApiDocument(){
        return axios.post(host+'/v1/mpgps/landerDashboard/pub_api/doc/',{},{headers : ApiUrlCall.getAuthHeaders()})
    }

    // Session Management APIs
    sessionHeartbeat() {
        return axios.post(host + '/v1/mpgps/landerDashboard/session/heartbeat/', {}, { headers: ApiUrlCall.getAuthHeaders() });
    }

    endSession() {
        return axios.post(host + '/v1/mpgps/landerDashboard/session/end/', {}, { headers: ApiUrlCall.getAuthHeaders() });
    }

    userLogout(refreshToken) {
        return axios.post(host + '/v1/mpgps/landerDashboard/logout/',
            { refresh_token: refreshToken || '' },
            { headers: ApiUrlCall.getAuthHeaders() }
        );
    }

    refreshToken() {
        const refresh_token = localStorage.getItem('refresh_token');
        return axios.post(host + '/v1/mpgps/landerDashboard/refresh-token/',
            { refresh_token: refresh_token }
        );
    }

    // Screen Activity Tracking APIs
    screenEnter(screenName) {
        const token = localStorage.getItem('token');
        if (!token) return Promise.resolve(null);
        return axios.post(host + '/v1/mpgps/landerDashboard/screen/enter/',
            { screen_name: screenName },
            { headers: ApiUrlCall.getAuthHeaders() }
        );
    }

    screenExit(screenName) {
        const token = localStorage.getItem('token');
        if (!token) return Promise.resolve(null);
        return axios.post(host + '/v1/mpgps/landerDashboard/screen/exit/',
            { screen_name: screenName },
            { headers: ApiUrlCall.getAuthHeaders() }
        );
    }

}

export default new ApiUrlCall();
